// 1PreLevel1.js
import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const PreLevelCard = ({ onStart, trainingType }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  // Update images based on training type to match exactly what's in the level files
  const getTrainingImages = () => {
    switch(trainingType) {
      case 'fashion':
        return [
          "https://processed.portal.soot.com/playground-static-assets/fashion1.png",
          "https://processed.portal.soot.com/playground-static-assets/fashion2.png",
          "https://processed.portal.soot.com/playground-static-assets/fashion3.png"
        ];
      case 'product':
        return [
          "https://processed.portal.soot.com/playground-static-assets/product1.png",
          "https://processed.portal.soot.com/playground-static-assets/product2.png",
          "https://processed.portal.soot.com/playground-static-assets/product3.png"
        ];
      case 'nature':
      default:
        return [
          "https://processed.portal.soot.com/playground-static-assets/wildlife1.png",
          "https://processed.portal.soot.com/playground-static-assets/wildlife2.png",
          "https://processed.portal.soot.com/playground-static-assets/wildlife3.png"
        ];
    }
  };

  const images = getTrainingImages();

  return (
    <div className="min-h-screen bg-[#2E2E2E]">
      <div className="relative h-screen flex flex-col items-center justify-center px-8">
        {/* Content */}
        <motion.div 
          className="text-center max-w-4xl mx-auto"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <h1 
            className="text-6xl font-bold mb-12 text-[#ECFF0F]"
            style={{ fontFamily: 'ABC Diatype Rounded Medium' }}
          >
            Find these images!
          </h1>

          {/* Image Grid */}
          <div className="grid grid-cols-3 gap-8 mb-12">
            {images.map((src, index) => (
              <motion.div
                key={index}
                className="aspect-square bg-gray-800 rounded-xl overflow-hidden shadow-lg"
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ 
                  duration: 0.6, 
                  delay: index * 0.2,
                  ease: [0.23, 1, 0.32, 1]
                }}
              >
                <img 
                  src={src}
                  alt={`Target ${index + 1}`}
                  className="w-full h-full object-cover"
                />
              </motion.div>
            ))}
          </div>

          {/* Button */}
          <motion.button 
            onClick={onStart}
            className="px-12 py-4 bg-[#ECFF0F] text-black rounded-lg text-2xl font-medium hover:bg-yellow-300 transition-colors"
            style={{ fontFamily: 'ABC Diatype Rounded Medium' }}
            whileHover={{ scale: 1.05 }}
            transition={{
              duration: 0.2,
              type: "spring",
              stiffness: 100,
              damping: 15
            }}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            I'm ready!
          </motion.button>
        </motion.div>
      </div>
    </div>
  );
};

export default PreLevelCard;